import React from 'react';
import ServicePage from '../../components/ServicePage';

const WhiteGloveMoving = () => (
  <ServicePage
    seoTitle="White Glove Moving Services | Navy Seals Moving"
    seoDescription="Premium white-glove moving: meticulous packing with premium materials, careful handling of antiques, art, and fine furniture, and placement in your new home, by our own experienced crews."
    headerTitle="White Glove Moving"
    introTitle="Our Finest Level of Service"
    intro={[
      "White glove is our premium service for households where everything, not just the fragile items, deserves meticulous handling. Every item is carefully packed, wrapped, and secured on the truck, treated with the same care as our own possessions.",
      "It's the level of service our customers choose for fine furniture, antiques, artwork, and homes where the details matter. The same dedicated crew handles your belongings at every step, and at delivery we don't just unload: we place furniture, reassemble what we disassembled, and leave your new home ready to live in.",
      "Navy Seals Moving has provided premium moves across the United States for over 20 years, fully licensed, bonded, and insured, with consistent 5-star ratings from our customers."
    ]}
    featuresTitle="What White Glove Includes"
    features={[
      {
        icon: 'icon_easel',
        title: 'Meticulous Packing',
        text: 'Premium packing materials and unhurried, methodical work. Every piece is wrapped and protected individually before it ever leaves the room.'
      },
      {
        icon: 'icon_group',
        title: 'Specialty Item Care',
        text: 'Antiques, pianos, artwork, mirrors, and delicate furniture handled by experienced movers who do this work every day.'
      },
      {
        icon: 'icon_house',
        title: 'Placement & Reassembly',
        text: 'At your new home we place every piece where you want it, reassemble furniture, and make sure nothing is left in the wrong room.'
      },
      {
        icon: 'icon_datareport',
        title: 'Climate-Controlled Storage',
        text: 'If your belongings need to wait, they wait in our own secure, climate-controlled warehouse, not a rented unit.'
      }
    ]}
  />
);

export default WhiteGloveMoving;
